import React from "react";

const QuickSearch = () => {
  return (
    <>
      <section className="quick-search">
        <span className="quick-search-heading">
          Hi, What are you looking for?
        </span>
        <div className="quick-options">
          <a href="#">
            <img
              className="quick-img"
              src=" https://img9.hkrtcdn.com/20077/bnr_2007668_o.png"
              alt="Sports
            nutrition"
            />
          </a>
          <a href="#">
            <img
              className="quick-img"
              src=" https://img9.hkrtcdn.com/21310/bnr_2130978_o.png"
              alt="Vitamin and supplements"
            />
          </a>
          <a href="#">
            <img
              className="quick-img"
              src=" 	https://img3.hkrtcdn.com/20077/bnr_2007672_o.png
              "
              alt="Ayurveda and Herbs"
            />
          </a>
          <a href="#">
            <img
              className="quick-img"
              src=" 	https://img5.hkrtcdn.com/20077/bnr_2007674_o.png"
              alt="Healthy Foods and Drinks"
            />
          </a>
          <a href="#">
            <img
              className="quick-img"
              src=" 	https://img5.hkrtcdn.com/20077/bnr_2007684_o.png"
              alt="Weight loss"
            />
          </a>
          <a href="#">
            <img
              className="quick-img"
              src=" https://img7.hkrtcdn.com/20077/bnr_2007676_o.png"
              alt="Wellness"
            />
          </a>
          <a href="#">
            <img
              className="quick-img"
              src="	https://img9.hkrtcdn.com/20077/bnr_2007678_o.png"
              alt="Immunity and wellbeing"
            />
          </a>
          <a href="#">
            <img
              className="quick-img"
              src="https://img1.hkrtcdn.com/20077/bnr_2007680_o.png"
              alt="Fitness"
            />
          </a>
        </div>
      </section>
    </>
  );
};

export default QuickSearch;
